"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserAuctionsResponseDto = instanceOfUserAuctionsResponseDto;
exports.UserAuctionsResponseDtoFromJSON = UserAuctionsResponseDtoFromJSON;
exports.UserAuctionsResponseDtoFromJSONTyped = UserAuctionsResponseDtoFromJSONTyped;
exports.UserAuctionsResponseDtoToJSON = UserAuctionsResponseDtoToJSON;
exports.UserAuctionsResponseDtoToJSONTyped = UserAuctionsResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var UserAuctionDto_1 = require("./UserAuctionDto");
/**
 * Check if a given object implements the UserAuctionsResponseDto interface.
 */
function instanceOfUserAuctionsResponseDto(value) {
    if (!('auctions' in value) || value['auctions'] === undefined)
        return false;
    return true;
}
function UserAuctionsResponseDtoFromJSON(json) {
    return UserAuctionsResponseDtoFromJSONTyped(json, false);
}
function UserAuctionsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'auctions': (json['auctions'].map(UserAuctionDto_1.UserAuctionDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function UserAuctionsResponseDtoToJSON(json) {
    return UserAuctionsResponseDtoToJSONTyped(json, false);
}
function UserAuctionsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'auctions': (value['auctions'].map(UserAuctionDto_1.UserAuctionDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
